import React, {useEffect} from 'react';
import VideoModal from './VideoModal';
import Modal from '../Modal';

const VideoImage = ({imgUrl, videoUrl}) => {

  const openModal = () => {
    Modal.open({
      children: <VideoModal
        videoUrl={videoUrl}
      />
    });
  }
  
  return (
    <a href={videoUrl} target="_blank">
      <img class="video-image" src={imgUrl} />
    </a>
  )
}

export default VideoImage;